import { resizeProperty } from '@/helpers';
import KatexRenderer from '../RichTextEditor/KatexRenderer';

export function Equation({ item, formValues = {}, containerWidth }) {
  return (
    <KatexRenderer
      equation={item.expression}
      inline={false}
      onDoubleClick={() => {}}
      style={{
        fontSize: resizeProperty(containerWidth, formValues.body_font_size),
        color: formValues.body_font_color,
      }}
    />
  );
}
